import { useState } from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';

import { cmsService } from '../../services/homii-services';

import HeroSection from '../../components/live-page-components/our-app/hero-section.component';
import MobileAppSection from '../../components/live-page-components/our-app/mobile-app-section.component';
import VideoSection from '../../components/live-page-components/video-section.component';
import MobileAppFeatures from '../../components/live-page-components/our-app/mobile-app-features.component';
import DownloadAppSection from '../../components/live-page-components/our-app/download-app-section.component';

// import NewBuildingDark from '../../components/live-page-components/our-app/new-building-dark.container';

import { Layout, Footer, MetaData } from '../../components/shared';

const OurApp = (props) => {

    const [offsetHeight, setOffsetHeight] = useState(null);
    
    const { data, baseUrlApp } = props;

    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroParagraph = _.get(data, 'acf.hero_paragraph');
    const heroImage = _.get(data, 'acf.hero_main_image');
    const heroImageAlt = _.get(data, 'acf.hero_main_image_alt');
    const appTitle = _.get(data, 'acf.app_section_title');
    const appParagraph = _.get(data, 'acf.app_section_paragraph');
    const appImage = _.get(data, 'acf.app_section_image.url');
    const appImageAlt = _.get(data, 'image_alt');
    const videoUrl = _.get(data, 'acf.video_url');
    const appFeatureTitle = _.get(data, 'acf.app_feature_title');
    const appFeatures = _.get(data, 'acf.app_features');
    const downloadAppTitle = _.get(data, 'acf.download_app_section_title');
    const downloadAppParagraph = _.get(data, 'acf.download_app_section_paragraph');
    const newBuildingTitle = _.get(data, 'acf.bulding_title');
    const newBuildingParagraph = _.get(data, 'acf.building_paragraph');

    return (

        <Layout>

            <MetaData
                title={seoTitle}
                desc={seoMetaDesc}
                canonical={`${baseUrlApp}/live/our-app`}
            />

            <div>

                <div className='corporate-container'>

                    <HeroSection
                        title={heroTitle}
                        paragraph={heroParagraph}
                        imgSrc={heroImage}
                        imgAlt={heroImageAlt}
                        id="our_app_header"
                    />

                </div>

                <div className='container-root container-root-maxWidthLg'>

                    <MobileAppSection
                        title={appTitle}
                        paragraph={appParagraph}
                        imgSrc={appImage}
                        imgAlt={appImageAlt}
                    />

                </div>

                <VideoSection
                    videoUrl={videoUrl}                    
                    marginTop={100}
                    marginBottom={220}
                    marginTopMobile={70}
                    marginBottomMobile={80}
                />

                <div className='container-root container-root-maxWidthLg'>

                     <div className="container">

                        <MobileAppFeatures
                            title={appFeatureTitle}
                            features={appFeatures}
                            className="Features"
                            setScrollOffsetHeight={setOffsetHeight}
                        />

                    </div>

                   <DownloadAppSection
                        title={downloadAppTitle}
                        paragraph={downloadAppParagraph}
                        offsetHeight={offsetHeight}
                    />

                </div>

                {/* <NewBuildingDark
                    title={newBuildingTitle}
                    paragraph={newBuildingParagraph}
                    isClient={isClient}
                    isSmallDesktop={isSmallDesktop}
                    isFilteredBuildings
                /> */}

            </div>

            <Footer />

        </Layout>
    );
};

export const getServerSideProps = async ({ }) => {
    const resp = await cmsService.RetrieveWordPressPage('our-app');    
    return {
        props: {
            data: resp
        }
    };
};

export default OurApp;

OurApp.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
};
